import React from 'react';
import './Whatsapp.scss';
import { FaWhatsapp } from 'react-icons/fa';

const Whatsapp: React.FC = () => {
  const handleClick = () => {
    const message = '¡Hola! cuéntame más sobre MedioPunto!';
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/56926974928?text=${encodedMessage}`, '_blank');
  };

  return (
    <div className="whatsapp-icon-container" onClick={handleClick}>
      <FaWhatsapp className="whatsapp-icon" />
    </div>
  );
};

export default Whatsapp;
